import {Route} from "react-router-dom";
import PublicHeader from "../../common/component/PublicHeader";
import {FullHeightWrapper} from "@commons/uinew/layout/FullHeightWrapper";
import DoctorFooter from "../../doctor/component/DoctorFooter";
import React, {lazy} from "react";

let WherebyCheckStep0Page = lazy(() => import("./WherebyCheckStep0Page"))
let WherebyResultsPage = lazy(() => import("./WherebyResultsPage"))
let WherebyTestPage = lazy(() => import("./WherebyTestPage"))

export let useWherebyRoutes = () => {
    return <>
        <Route path={`/whereby/test-results`} element={<>
            <PublicHeader shadow={false} showCta={false}/>
            <FullHeightWrapper>
                <WherebyResultsPage/>
            </FullHeightWrapper>
            <DoctorFooter variant={'dark'}/>
        </>}/>

        <Route path={`/whereby/test`} element={<>
            <WherebyTestPage/>
        </>}/>

        <Route path={`/whereby`} element={<>
            <PublicHeader shadow={false} showCta={false}/>
            <FullHeightWrapper>
                <WherebyCheckStep0Page/>
            </FullHeightWrapper>
            <DoctorFooter variant={'dark'}/>
        </>}/>

    </>
}